export default "__VITE_ASSET__D8yz4YZL__"